import { initializeBrowserTelemetry } from "./lib/browser-telemetry";

// Next.js executes this before hydration, including when the root layout fails.
initializeBrowserTelemetry();
